import { useState } from 'react';
import { toast } from 'sonner';
import axios from 'axios';
import { useBargain } from 'app/BargainWidget/context/BargainContext';

const useCreateOffer = () => {
  const {handleChangeModalView, handleCloseModalView, setAcceptedOfferData} = useBargain();
  const [loading, setLoading] = useState(false);
  const [isCreated, setIsCreated] = useState(false);

  const handleCreateOffer = async (payload) => {
    setLoading(true);
    try {
      const response = await axios.post('/api/create-an-offer', payload);
      const data = response?.data;
      if (data?.status === 200) {
        if(data?.['offerStatus'] === "COUNTEROFFER_CREATED" || data?.['offerStatus'] === "OFFER_ACCEPTED") {
          setAcceptedOfferData(data);
          setTimeout(() => handleChangeModalView("offer_accepted"), 300);
        } else {
          toast.success(data?.message || 'Offer successfully created');
          handleCloseModalView();
        }
        setIsCreated(true);
      } else {
        toast.error(data?.message || 'Something went wrong');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return { handleCreateOffer, loading, isCreated };
};

export default useCreateOffer;
